import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import FieldFormLayout from './containers/FieldsForm';
import FormsGridLayout from './containers/Grid';

export default function FormLayout() {
  return <Router>
    <PrivateRoute path="/offer/forms/:id/fields" component={FieldFormLayout} />
    <PrivateRoute path="/offer/forms" component={FormsGridLayout} />
  </Router>
}
